import { ERROR_CODES } from '@/consts';

export default class UserNotFound extends Error {
  static code = ERROR_CODES.AUTH_USER_NOT_FOUND;

  constructor(message) {
    super(message || 'User not found.');
    this.code = ERROR_CODES.AUTH_USER_NOT_FOUND;
  }
}
